// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__eJBl1","tagClickable":"Tag_tagClickable__2nLDT","tagDisabled":"Tag_tagDisabled__nwxjy","tagLabel":"Tag_tagLabel__nBqp3","tagClose":"Tag_tagClose__DaxPN"};